export default function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}
